module.exports = __webpack_public_path__ + "images/b0223b53733fae500da9f54f54d71a1e.jpg";